import React from 'react';
import type { FC } from 'react';

import { SlideIn, ExitingPersistence } from '@atlaskit/motion';
import { Box, xcss } from '@atlaskit/primitives';

import { type PremiumTipPromptProps, PremiumTipPrompt } from './PremiumTipPrompt';

type PremiumTipPromptSlideInProps = PremiumTipPromptProps & {
	shouldShow?: boolean;
};

const containerStyles = xcss({
	position: 'fixed',
	top: 'space.800',
	right: 'space.250',
	zIndex: 'layer',
});

export const PremiumTipPromptSlideIn: FC<PremiumTipPromptSlideInProps> = ({
	shouldShow,
	...props
}) => {
	return (
		<Box xcss={containerStyles}>
			<ExitingPersistence appear>
				{shouldShow && (
					<SlideIn enterFrom="right" exitTo="right" fade="in">
						{(slideInProps) => {
							return (
								<div {...slideInProps}>
									<PremiumTipPrompt {...props} />
								</div>
							);
						}}
					</SlideIn>
				)}
			</ExitingPersistence>
		</Box>
	);
};
